import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router'
import i18n from './locales'

import $ from 'jquery';
import '../node_modules/jquery/dist/jquery.js';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../node_modules/bootstrap/dist/js/bootstrap.min.js';
import Swiper from "swiper"
import '../node_modules/swiper/dist/css/swiper.min.css';
import animate from 'animate.css'

import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
Vue.use(ViewUI);

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    el: '#app',
    store,
    router,
    i18n,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js